'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const DynamicMetadata = () => {
  const pathName = usePathname();
  const [pageTitle, setPageTitle] = useState('VERTELIER');
  const [pageDescription, setPageDescription] = useState(
    'Shop your jewellery from vertelier.'
  );

  useEffect(() => {
    switch (pathName) {
      case '/':
        setPageTitle('Custom Lab-Grown Diamond Jewelry Online | Vertelier');
        setPageDescription(
          'Discover unique, customized lab-grown diamond jewelry online in the USA with Vertelier – where luxury meets affordability. Shop now for timeless beauty!'
        );
        break;

      case '/engagement':
        setPageTitle(
          'Shop Lab-Grown Diamond Engagement Rings Online | Vertelier'
        );
        setPageDescription(
          'Explore lab-grown diamond engagement rings online in the USA at Vertelier – ethical, elegant, and affordable designs. Shop now for lasting brilliance!'
        );
        break;

      case '/essential':
        setPageTitle(
          'Lab-Grown Diamond Necklaces for Women Online | Vertelier'
        );
        setPageDescription(
          'Shop elegant lab-grown diamond necklaces for women at Vertelier. Exceptional quality meets ethical, affordable luxury. Order now for lasting beauty!'
        );
        break;

      case '/customization':
        setPageTitle('Custom Lab-Grown Bridal Jewelry Online | Vertelier');
        setPageDescription(
          'Design your dream bridal jewelry with Vertelier. One-of-a-kind lab-grown diamond pieces crafted for your special day. Order now for timeless elegance!'
        );
        break;
    }
  }, [pathName]);

  useEffect(() => {
    document.title = pageTitle;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', pageDescription);
  }, [pageTitle, pageDescription]);
  return null;
};

export default DynamicMetadata;
